<script setup lang="ts">
const eventStore = useEventStore();
const groupStore = useGroupStore();

// This loading will change only on first load.
const isLoading = computed(() => eventStore.isLoading || groupStore.isLoading);
</script>

<template>
  <div class="event-page-container">
    <EventViewForm
      :event="eventStore.eventDetail"
      :is-loading="isLoading"
    />
  </div>
</template>